import { ISvgProps } from '@src/types';

const QuestionAndAnswerIcon = ({
  width = '26px',
  height = '22px',
  color = 'var(--font-color)',
  ...props
}: ISvgProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      color={color}
      viewBox="0 0 26 22"
      {...props}
    >
      <path
        fill="currentColor"
        transform="translate(0 1.38283e-05)"
        d="M12.074262 9.7109375L12.074262 1.9335938C12.074262 0.86741018 11.206852 0 10.140668 0L1.9335938 0C0.86741018 0 0 0.86741018 0 1.9335938L0 9.7109375C0 10.777122 0.86741018 11.644531 1.9335938 11.644531L2.9004335 11.644531L3.9961367 13.105426C4.254035 13.449305 4.7700467 13.448574 5.0273867 13.105426L6.1230898 11.644531L10.140668 11.644531C11.206852 11.644531 12.074262 10.777122 12.074262 9.7109375ZM8.705555 8.4643707C8.4539299 8.7160387 8.0457697 8.7161245 7.7940588 8.4643707L7.5551953 8.2255077C7.1135626 8.5070391 6.5900311 8.6709223 6.0286016 8.6709223C4.4578362 8.6709223 3.1799023 7.3930311 3.1799023 5.8222656C3.1799023 4.2514572 4.4578362 2.9735663 6.0286016 2.9735663C7.5994101 2.9735663 8.8773012 4.2515001 8.8773012 5.8222656C8.8773012 6.3656483 8.7242031 6.8739257 8.4590855 7.3064494L8.705512 7.552875C8.9572659 7.8045859 8.9572659 8.2126598 8.705555 8.4643707L8.705555 8.4643707Z"
      />
      <path
        fill="currentColor"
        transform="translate(4.46901 4.26264)"
        d="M1.5596367 0C0.69966018 0 0 0.69966018 0 1.5596367C0 2.6601524 1.1139219 3.413996 2.1329257 3.0096171L1.9147735 2.7914648C1.6630625 2.5397968 1.6630625 2.1316798 1.9147735 1.8799688C2.1664414 1.6282579 2.5745585 1.6282579 2.8262696 1.8799688L3.0288243 2.0825233C3.3904061 1.0696641 2.6349726 0 1.5596367 0Z"
      />
      <path
        fill="currentColor"
        transform="translate(15.5701 10.4321)"
        d="M0 1.045043L0.79238671 1.045043L0.39801952 0L0 1.045043Z"
      />
      <path
        fill="currentColor"
        transform="translate(9.92574 5.19897)"
        d="M10.140668 0L3.4375858 0L3.4375858 4.5119767C3.4375858 6.288949 1.9919024 7.734633 0.21492968 7.734633L0 7.734633L0 9.7109375C0 10.777122 0.86741018 11.644531 1.9335938 11.644531L5.951086 11.644531L7.0467892 13.105426C7.3047304 13.449305 7.8206992 13.448531 8.0780392 13.105426L9.1737423 11.644531L10.140668 11.644531C11.206852 11.644531 12.074262 10.777122 12.074262 9.7109375L12.074262 1.9335938C12.074262 0.86741018 11.206852 0 10.140668 0L10.140668 0ZM8.0049496 8.6082306C7.6731443 8.7334414 7.3005195 8.5671091 7.1743631 8.2328129L6.9232111 7.5672693L5.1533709 7.5672693L4.8992109 8.2346172C4.7725391 8.5672817 4.4000859 8.7342577 4.0675077 8.607543C3.7348437 8.4808712 3.5679102 8.1084614 3.694582 7.7758398L5.3498673 3.4295938C5.4547968 3.1524882 5.7247696 2.9526837 6.0438986 2.9523394C6.3455391 2.952039 6.6171017 3.1315196 6.7331171 3.4136093C6.7387462 3.4273164 6.6650977 3.232625 8.3803244 7.7776017C8.5060511 8.1106949 8.3379574 8.4825468 8.0049496 8.6082306Z"
      />
    </svg>
  );
};

export default QuestionAndAnswerIcon;
